export default {
  years: 'años',
  askInfo: 'Solicitar información',
  comingSoon: 'Próximamente',
  knowMore: 'Quiero saber más',
  ageBetween: '{startAge} a {endAge} años',
  untitled: 'Sin título',
  seeUsedRecord: 'Ver registro de uso',
  options: {
    addLanguage: 'Agregar nuevo idioma',
    addCollaborators: 'Agregar colaboradores',
    changeContentType: 'Cambiar tipo de contenido',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    editKeywords: 'Editar palabras clave',
    delete: 'Eliminar'
  }
}

export const en = {
  years: 'years',
  askInfo: 'Request information',
  comingSoon: 'Coming soon',
  knowMore: 'I want to find out more',
  ageBetween: '{startAge} to {endAge} y/o',
  untitled: 'Untitled',
  seeUsedRecord: 'View usage record',
  options: {
    addLanguage: 'Add new language',
    addCollaborators: 'Add collaborators',
    changeContentType: 'Change content type',
    publish: 'Post',
    unpublish: 'Unpost',
    editKeywords: 'Edit keywords',
    delete: 'Delete'
  }
}

export const ca = {
  years: 'anys',
  askInfo: 'Sol·licitar informació',
  comingSoon: 'Pròximament',
  knowMore: 'Explica\'m més',
  ageBetween: 'De {startAge} a {endAge} anys',
  untitled: 'Sense títol',
  seeUsedRecord: 'Veure registre d\'ús',
  options: {
    addLanguage: 'Afegir nou idioma',
    addCollaborators: 'Afegir col·laboradors',
    changeContentType: 'Canviar tipus de contingut',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    editKeywords: 'Editar paraules clau',
    delete: 'Eliminar'
  }
}
